import { getTenantName } from '../../AlmeUtilities/Alme-utils';
const ResponseActionName = "SwitchAccountConfirmation";
const AppEventName = "SwitchAccountExecute";
const validateResponseActionName = (actionName) => {
    return actionName === ResponseActionName;
};
export function processSwitchAccountConfirmationAction(response, almeApiUtils, almeState, setAlmeState, isAccountSwitched, props) {
    try {
        if (!(response === null || response === void 0 ? void 0 : response.responseActions)) {
            return;
        }
        for (const action of response.responseActions) {
            if (validateResponseActionName(action.Name) && action.enterpriseId) {
                const userMetaData = props.appConfig.main.userMetadata;
                userMetaData.currentEnterpriseId = action.enterpriseId;
                almeApiUtils.sendAppEvent(AppEventName, undefined, { "currentEnterpriseId": action.enterpriseId })
                    .then((resp) => {
                    almeApiUtils.appendToHistory(resp);
                    const platform = almeApiUtils.getPlatform({ "currentEnterpriseId": action.enterpriseId });
                    const accessKey = getTenantName(platform).value;
                    isAccountSwitched.current = true;
                    setAlmeState(Object.assign(Object.assign({}, almeState), { accessKey: accessKey, currentEnterpriseId: userMetaData.currentEnterpriseId, isOpen: !almeState.isOpen ? true : almeState.isOpen, lastEntryId: resp ? resp.extensionData.entryId : undefined }));
                })
                    .catch((error) => console.error(error));
                return;
            }
        }
    }
    catch (error) {
        console.error(error);
    }
}
